import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { ExpressionPath, FilterPath, ExpSide, isExpressionPath, isLiteral, ExpressionFunctionSpec, Literal, FuncArgPath } from '../types';
import { FilterContext } from './FilterContainer';
import { GridScope, GridContext } from '../../components/DataGrid';
import ExpressionPathBuilder from './ExpressionPathBuilder';


const ExpressionFuncArgs: React.FC<{
    expressionPath: ExpressionPath,
    filterPath: FilterPath,
    side: ExpSide,
    depth: number,
    argPath: FuncArgPath,
    hidden: boolean,
    rhsIndex?: number,
}> = ({
    expressionPath,
    filterPath,
    side,
    depth,
    argPath,
    hidden,
    rhsIndex,
}) => {
        const dispatch = useDispatch();
        const gridScope: GridScope = useContext(GridContext)!;
        const { disabled } = useContext(FilterContext)!;

        const {
            args,
            spec: {
                args: argSpecs,
                name,
                returns
            }
        } = expressionPath.func!;

        return <>
            {
                argSpecs.map((argSpec, argIndex) => {
                    // switch (arg) {
                    //     case 'boolean':
                    //         return 'boolean';
                    //     case 'string':
                    //         return 'string';
                    //     case 'date':
                    //         return 'date';
                    //     case 'number':
                    //         return 'number';
                    // }

                    const arg = args[argIndex];
                    // const literal: Literal | null = isLiteral(arg) ? arg as Literal : null;
                    const expressionPath: ExpressionPath | null = (arg != null) && isExpressionPath(arg) ? arg as ExpressionPath : null;

                    return <ExpressionPathBuilder
                        expressionPath={expressionPath!}
                        filterPath={filterPath}
                        side={side}
                        argPath={[...argPath, { depth, argIndex }]}
                        key={argIndex}
                        hidden={hidden}
                        rhsIndex={rhsIndex}
                    />

                })
            }
        </>
    }

export default ExpressionFuncArgs;
